module.exports = {"pressInquiries":"Fyrirspurnir frá fjölmiðlum","pressText":"Hafðu samband við","logoTitle":"Skákgreind (SciChess) Logo","logoInfo":"SciChess og OcuChess eru skráð vörumerki. Það er ekki leyfilegt að nota SciChess lógóið nema með samþykki frá scichess.com og jafnvel þá einungis með því að nefna einnig scichess.com. Ekki er leyfilegt að blanda lógói Scichess saman við önnur lógó.","downloadLogo":"Sækja myndi í fullu upplausn","inTheNews":"SciChess í fréttunum"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/about/is/newsroom.yml
// module id = 934
// module chunks = 267892159731516